import { TextProps } from '../../atoms/Text';
import { TagProps } from '../Tag';


type EventInfoInternalProps = {
  title?: TextProps;
  date?: TextProps;
  time?: TextProps;
  location?: TextProps;
  price?: TextProps;
  exclusive?: TagProps;
  tag?: TagProps;
};

type EventInfoPropsValues = {
  'DefaultDefault': EventInfoInternalProps;
  'DefaultExclusive': EventInfoInternalProps;
  'SoldOutDefault': EventInfoInternalProps;
  'SoldOutExclusive': EventInfoInternalProps;
};

const propValues: EventInfoPropsValues = {
  'DefaultDefault': {
    title: {
      type: 'CardBody',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    date: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    time: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    location: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    price: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'Positive',
      align: 'Left',
    },
  },
  'DefaultExclusive': {
    exclusive: {
      type: 'Information',
      size: 'Small',
    },
    title: {
      type: 'CardBody',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    date: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    time: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    location: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    price: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'Positive',
      align: 'Left',
    },
  },
  'SoldOutDefault': {
    title: {
      type: 'CardBody',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    date: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    time: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    location: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    tag: {
      type: 'Negative',
      size: 'Small',
    },
  },
  'SoldOutExclusive': {
    exclusive: {
      type: 'Information',
      size: 'Small',
    },
    title: {
      type: 'CardBody',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    date: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    time: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    location: {
      type: 'CardBody',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
    tag: {
      type: 'Negative',
      size: 'Small',
    },
  },
};

const getProps = (type: string): EventInfoInternalProps => {
  const values: EventInfoInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
